import React from 'react'
import { Link } from 'react-router-dom'

export default function RishikeshBook() {
  return (
    <>
    <section className="rishikesh-book">
        <div className="container">
            <div className="row justify-content-end">
                 
                <div className="col-lg-6 col-sm-7 col-md-6">
                    <div className="rishikesh-bookdetail">
                        <h2 className='heading'>Among Sacred Shivalik Foothills, Explore With Intention...</h2>
                        <p>Sunrise meditation by the Ganges. Rejuvenating Ayurvedic spa rituals. Authentic vegetarian cuisine with mountain views. Time to reconnect with your inner self. Attune yourself to ancient wisdom through mindful practices and return each day to the luxurious serenity and spiritual calm of home in the heart of it all.</p>
                        <Link to="https://www.swiftbook.io/inst/#/home?propertyId=682NTPc7dd5tQYOO7KblEIVgpgsly1qSD956Ilzg2MDU=&JDRN=Y&RoomID=255031,255032,255033,255034,255035&ap=1&gsId=682NTPc7dd5tQYOO7KblEIVgpgsly1qSD956Ilzg2MDU=" className="arrow-butn" target='_blank'>Book A Stay <img src="/image/right-arrow.svg" alt="arrow" /></Link>
                    </div>

                    <img src="/image/rishikesh-book.webp" className="img-responsive" alt="rishikesh" loading="lazy"/>
                </div>

            </div>
        </div>

        <div className='big-container rishbook-shape'>
            <img src="/image/shell-shape.webp" alt="shape" loading="lazy"/>
        </div>
    </section>
    </>
  )
}
